import React from 'react';

const Service = ({ item, i }) => {
    return (
        <div className="group relative">
            <div className=' p-1  rounded-lg cursor-pointer'>
                {/* <div className="pb-2 flex justify-center">
                <img src={item.img} alt="" />
            </div> */}
                <div className="text-s">
                    <h2 className="mb-2 text-xl font-poppins text-transparent bg-clip-text font-extrabold bg-gradient-to-r from-green-400 to-blue-500">{item.name}</h2>
                    <p className="text-sm font-poppins ">{item.dash}</p>
                </div>
            </div>
            <div className="absolute top-0 -left-2 hover:transition-all ease-in-out delay-150 duration-300 flex justify-center items-center w-1 group-hover:w-full h-full rounded-xl  bg-gradient-to-r from-green-400 to-blue-500">
                <div className='text-center opacity-0 group-hover:opacity-100 hover:transition-all ease-in-out delay-150 duration-300'>
                    <h2 className="text-5xl text-white font-poppins font-extrabold">{i + 1}</h2>
                    <h2 className='text-white font-extrabold font-poppins text-xl'>{item.name}</h2>
                </div>
            </div>
        </div>
    );
};

export default Service;